(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.CjsFulfilmentCalendar = api;
})(typeof globalThis === 'object' ? globalThis : this, function () {
  const dayMs = 86400000;
  const iso = (date) => date.toISOString().slice(0, 10);
  const nextDay = (date) => new Date(date.getTime() + dayMs);

  // All calendar arithmetic uses Perth's date, independently of the visitor's time zone.
  function estimate(schedule, timestamp) {
    if (!schedule || schedule.timezone !== 'Australia/Perth' || !Number.isFinite(timestamp) ||
        !Array.isArray(schedule.batches) || !Number.isSafeInteger(schedule.bufferBusinessDays) ||
        schedule.bufferBusinessDays < 0 || schedule.bufferBusinessDays > 10) return null;
    const perth = new Date(timestamp + 480 * 60000);
    let date = new Date(Date.UTC(perth.getUTCFullYear(), perth.getUTCMonth(), perth.getUTCDate()));
    const today = iso(date);
    if (!schedule.validThrough || today > schedule.validThrough) return null;
    const closed = new Set(schedule.closedDates || []);
    const excluded = new Set(schedule.excludedBatchDates || []);
    const businessDay = (value) => value.getUTCDay() !== 0 && value.getUTCDay() !== 6 && !closed.has(iso(value));
    for (let offset = 0; offset < 28; offset++, date = nextDay(date)) {
      if (excluded.has(iso(date))) continue;
      const batch = schedule.batches.find(item => item.day === date.getUTCDay());
      if (!batch || !Number.isSafeInteger(batch.cutoffMinutes) || batch.cutoffMinutes < 0 || batch.cutoffMinutes >= 1440 ||
          !Number.isSafeInteger(batch.arrivalOffsetDays) || batch.arrivalOffsetDays < 1 || batch.arrivalOffsetDays > 60) continue;
      const cutoff = date.getTime() + batch.cutoffMinutes * 60000 - 480 * 60000;
      if (timestamp >= cutoff) continue;
      let arrival = new Date(date.getTime() + batch.arrivalOffsetDays * dayMs);
      while (!businessDay(arrival)) arrival = nextDay(arrival);
      let dispatch = arrival;
      for (let extra = 0; extra < schedule.bufferBusinessDays; extra++) {
        do { dispatch = nextDay(dispatch); } while (!businessDay(dispatch));
      }
      if (iso(dispatch) > schedule.validThrough) return null;
      return { batchDate: iso(date), arrivalDate: iso(arrival), dispatchDate: iso(dispatch), cutoffAt: new Date(cutoff).toISOString() };
    }
    return null;
  }

  // Transit counts business days after dispatch, using the same reviewed holiday calendar.
  function deliveryRange(schedule, dispatchDate, minimum = 2, maximum = 8) {
    if (!schedule || schedule.timezone !== 'Australia/Perth' || !schedule.validThrough ||
        !/^\d{4}-\d{2}-\d{2}$/.test(dispatchDate || '') || !Number.isSafeInteger(minimum) ||
        !Number.isSafeInteger(maximum) || minimum < 0 || maximum < minimum || maximum > 60) return null;
    let date = new Date(dispatchDate + 'T00:00:00Z');
    if (!Number.isFinite(date.getTime()) || iso(date) !== dispatchDate || dispatchDate > schedule.validThrough) return null;
    const closed = new Set(schedule.closedDates || []);
    let minimumDate = minimum === 0 ? dispatchDate : null;
    for (let days = 0; days < maximum;) {
      date = nextDay(date);
      if (iso(date) > schedule.validThrough) return null;
      if (date.getUTCDay() === 0 || date.getUTCDay() === 6 || closed.has(iso(date))) continue;
      days++;
      if (days === minimum) minimumDate = iso(date);
    }
    return { minimumDate, maximumDate: iso(date) };
  }

  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const weekdays = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  const ordinal = day => `${day}${day % 100 >= 11 && day % 100 <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th')}`;
  const referenceYear = timestamp => Number.isFinite(timestamp) ? new Date(timestamp + 480 * 60000).getUTCFullYear() : null;

  function formatRange(range, referenceTimestamp) {
    const first = new Date(range.minimumDate + 'T12:00:00Z');
    const last = new Date(range.maximumDate + 'T12:00:00Z');
    const sameYear = first.getUTCFullYear() === last.getUTCFullYear();
    const sameMonth = sameYear && first.getUTCMonth() === last.getUTCMonth();
    const yearNeeded = !sameYear || last.getUTCFullYear() !== referenceYear(referenceTimestamp);
    const minimum = ordinal(first.getUTCDate()) + (sameMonth ? '' : ` ${months[first.getUTCMonth()]}`) + (!sameYear ? ` ${first.getUTCFullYear()}` : '');
    const maximum = `${ordinal(last.getUTCDate())} ${months[last.getUTCMonth()]}` + (yearNeeded ? ` ${last.getUTCFullYear()}` : '');
    return `${minimum} to ${maximum}`;
  }

  function formatDate(value, referenceTimestamp) {
    const date = new Date(value + 'T12:00:00Z');
    return `${weekdays[date.getUTCDay()]} ${ordinal(date.getUTCDate())} ${months[date.getUTCMonth()]}` +
      (date.getUTCFullYear() !== referenceYear(referenceTimestamp) ? ` ${date.getUTCFullYear()}` : '');
  }
  return { estimate, deliveryRange, formatRange, formatDate };
});
